import React, { useState } from 'react';
import { contactAPI } from '../services/api';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await contactAPI.submit(formData);
      if (response.data.success) {
        setSubmitStatus({
          type: 'success',
          message: 'Thank you for your message! We will get back to you soon.'
        });
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setSubmitStatus({ type: '', message: '' }), 5000);
      }
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message: error.response?.data?.message || 'An error occurred. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  const waysToJoin = [
    {
      title: 'Become a Volunteer',
      desc: 'Participate in local or international missions while developing your skills and competencies.',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfDmock-placeholder-volunteer/viewform'
    },
    {
      title: 'Become a Partner',
      desc: 'Collaborate with EFIS to design and implement joint initiatives.',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfDmock-placeholder-partner/viewform'
    },
    {
      title: 'Propose a Project',
      desc: 'Have an idea? We support innovative projects aligned with our mission.',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfDmock-placeholder-project/viewform'
    },
    {
      title: 'Participate in Our Programs',
      desc: 'Express your interest in joining our upcoming programs and activities.',
      formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfDmock-placeholder-programs/viewform'
    }
  ];

  return (
    <>
      {/* Hero Start */}
      <div className="slider-area2">
        <div className="slider-height2 d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="hero-cap hero-cap2 pt-20 text-center">
                  <h2>Join & Contact Us</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Ways to Join Cards */}
      <div className="service-area section-padding30" style={{background: '#fff', borderBottom: '1px solid #e2e8f0', marginBottom: '50px'}}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-7 col-md-10">
              <div className="section-tittle text-center mb-80">
                <span>Join Our Community</span>
                <h2>Ways to Engage with EFIS</h2>
                <p>Click on any option below to fill out our application form and start cooperating with us.</p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {waysToJoin.map((option, index) => (
              <div key={index} className="col-lg-6 col-md-6 mb-30">
                <a 
                  href={option.formUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="single-cat h-100 text-center p-40 d-block" 
                  style={{
                    border: '1px solid #e2e8f0', 
                    borderRadius: '12px', 
                    background: '#fff', 
                    boxShadow: '0 5px 20px rgba(0,0,0,0.02)', 
                    transition: 'all 0.3s',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = 'var(--accent-red)';
                    e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = '#e2e8f0';
                    e.currentTarget.style.boxShadow = '0 5px 20px rgba(0,0,0,0.02)';
                  }}
                >
                  <div className="cat-cap">
                    <h4 style={{fontWeight: '700', color: '#1e293b', marginBottom: '15px'}}>{option.title}</h4>
                    <p style={{fontSize: '14.5px', color: '#64748b', lineHeight: '1.6'}}>{option.desc}</p>
                    <div style={{marginTop: '25px', color: 'var(--accent-red)', fontWeight: '600', fontSize: '15px'}}>
                      Apply Now →
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="contact-title">Get in Touch</h2>
            </div>
            <div className="col-lg-8">
              <form className="form-contact contact_form" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <textarea className="form-control w-100" name="message" id="message" cols="30" rows="9" 
                        placeholder="Enter Message" value={formData.message} onChange={handleChange} required></textarea>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input className="form-control valid" name="name" id="name" type="text" 
                        placeholder="Enter your name" value={formData.name} onChange={handleChange} required />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <input className="form-control valid" name="email" id="email" type="email" 
                        placeholder="Email" value={formData.email} onChange={handleChange} required />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <input className="form-control" name="subject" id="subject" type="text" 
                        placeholder="Enter Subject" value={formData.subject} onChange={handleChange} />
                    </div>
                  </div>
                </div>
                <div className="form-group mt-3">
                  <button type="submit" className="button button-contactForm boxed-btn" disabled={loading}>
                    {loading ? 'Sending...' : 'Send'}
                  </button>
                </div>
                {submitStatus.message && (
                  <div className="alert mt-3" style={{
                    padding: '15px',
                    borderRadius: '5px',
                    background: submitStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                    color: submitStatus.type === 'success' ? '#155724' : '#721c24',
                    border: `1px solid ${submitStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`
                  }}>
                    {submitStatus.message}
                  </div>
                )}
              </form>
            </div>
            <div className="col-lg-3 offset-lg-1">
              <div className="media contact-info">
                <span className="contact-info__icon"><i className="ti-home"></i></span>
                <div className="media-body">
                  <h3>Siedlce, Poland</h3>
                  <p>Europe Foundation for International Solidarity</p>
                </div>
              </div>
              <div className="media contact-info">
                <span className="contact-info__icon"><i className="ti-tablet"></i></span>
                <div className="media-body">
                  <h3>0048516160255</h3>
                  <p>Mon to Fri 9am to 5pm</p>
                </div>
              </div>
              <div className="media contact-info">
                <span className="contact-info__icon"><i className="ti-email"></i></span>
                <div className="media-body">
                  <h3>contact.efis2025@gmail.com</h3>
                  <p>Send us your query anytime!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;